import { useCallback, useEffect, useRef, useState } from "react";

// While a load has failed, the global toast's Retry (window "am:retry") reloads it.
export const useRetryOnError = (error, load) => {
  const ref = useRef(load);
  ref.current = load;
  useEffect(() => {
    if (!error) return undefined;
    const on = () => ref.current();
    window.addEventListener("am:retry", on);
    return () => window.removeEventListener("am:retry", on);
  }, [error]);
};

export const useFetch = (fn, deps = [], pollMs = 0, shouldPoll = () => false) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(() => fn().then((d) => { setData(d); setError(null); return d; }).catch(setError), deps); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setData(null); load(); }, [load]);
  useRetryOnError(error, load);
  const polling = pollMs > 0 && data && shouldPoll(data);
  useEffect(() => {
    if (!polling) return undefined;
    const id = setInterval(load, pollMs);
    return () => clearInterval(id);
  }, [polling, load, pollMs]);
  return { data, error, reload: load, setData };
};
